import * as actions from './actions';
import * as getters from './getters';
import { FETCH_HOME_TEXT_CONTENT } from '../../mutation-types';


const mutations = {
  [FETCH_HOME_TEXT_CONTENT](state, payload) {
    state.contentObject = payload
  },
};

const state = {
  contentObject: null,
  url: '/v1/contents'
};

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};
